import { Button, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { Modules } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import { get, post } from '../../axios/apiService';
import toast from 'react-hot-toast';

const SystemConfiguration = () => {
  const [permissionMatrix, setPermissionMatrix] = useState({});
  const [values, setValues] = useState();

  const GetConfig = async () => {
    try {
      const response = await get(`/SystemConfiguration`, null);
      setValues(response);
    } catch (error) {
      console.log(error);
    }
  };

  const SaveConfig = async () => {
    try {
      const response = await post(`/SystemConfiguration`, values);
      if (response) {
        toast.success('Saved Successfully');
      } else {
        toast.error('Something went wrong');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    var val = values.find((x) => x.key == name);
    val.key = name;
    val.value = value;

    setValues([...values]);
  };

  useEffect(() => {
    GetConfig();
  }, []);

  useEffect(() => {
    const UserPermissions = JSON.parse(localStorage.getItem(`UserPermissions`));
    const permission = UserPermissions?.find((x) => x.moduleId === Modules.SystemConfiguration);
    if (permission) {
      setPermissionMatrix(permission);
    } else {
      setPermissionMatrix(null);
    }
  }, []);

  return (
    <>
      <MainCard title="System Configuration">
        <Grid container spacing={3}>
          <Grid item xs={6} lg={6}>
            <Grid container spacing={3}>
              {values?.map((value) => {
                return (
                  <Grid key={value} item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={9}>
                        <TextField
                          fullWidth
                          name={value?.key}
                          type="text"
                          label={value?.key}
                          value={value?.value}
                          onChange={handleTextChange}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          <Grid item xs={6} lg={6}></Grid>
        </Grid>

        {permissionMatrix && permissionMatrix.writeRights === true ? (
          <Button variant="contained" sx={{ marginTop: '20px', padding: '5px 30px' }} onClick={SaveConfig}>
            Save
          </Button>
        ) : (
          <></>
        )}
      </MainCard>
    </>
  );
};

export default SystemConfiguration;
